const BlogThumbs = [
    {
        "title": "Pathtracer Milestone",
        "desc": "Progress on implementing Photon Mapping to the pathtracer",
        "url": "/blogs/pathtracer"
    },
    {
        "title": "Complete Pathtracer",
        "desc": "Finished Monte Carlo pathtracer with full photon mapping functionality",
        "url": "/blogs/pathtracer_done"
    }
];

export default BlogThumbs;